export const protocol = window.location.protocol;
export const hostnameApi = process.env.NODE_ENV === 'production' ? `api.${window.location.hostname}` : window.location.hostname;